/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { ClosedEnum } from "../../types/enums.js";

/**
 * The trigger status.
 */
export const UpdateTriggerInstanceFormStatus = {
  Active: "active",
  Paused: "paused",
} as const;
/**
 * The trigger status.
 */
export type UpdateTriggerInstanceFormStatus = ClosedEnum<
  typeof UpdateTriggerInstanceFormStatus
>;

/**
 * The trigger target kind.
 */
export const UpdateTriggerInstanceFormTargetKind = {
  Assistant: "assistant",
  Noop: "noop",
} as const;
/**
 * The trigger target kind.
 */
export type UpdateTriggerInstanceFormTargetKind = ClosedEnum<
  typeof UpdateTriggerInstanceFormTargetKind
>;

export type UpdateTriggerInstanceForm = {
  /**
   * The trigger config payload.
   */
  config?: { [k: string]: any } | undefined;
  /**
   * The linked environment ID.
   */
  environmentId?: string | undefined;
  /**
   * The trigger instance ID.
   */
  id: string;
  /**
   * The trigger instance name.
   */
  name?: string | undefined;
  /**
   * The trigger status.
   */
  status?: UpdateTriggerInstanceFormStatus | undefined;
  /**
   * The user-facing target display value.
   */
  targetDisplay?: string | undefined;
  /**
   * The trigger target kind.
   */
  targetKind?: UpdateTriggerInstanceFormTargetKind | undefined;
  /**
   * The opaque target reference.
   */
  targetRef?: string | undefined;
};

/** @internal */
export const UpdateTriggerInstanceFormStatus$outboundSchema: z.ZodMiniEnum<
  typeof UpdateTriggerInstanceFormStatus
> = z.enum(UpdateTriggerInstanceFormStatus);

/** @internal */
export const UpdateTriggerInstanceFormTargetKind$outboundSchema: z.ZodMiniEnum<
  typeof UpdateTriggerInstanceFormTargetKind
> = z.enum(UpdateTriggerInstanceFormTargetKind);

/** @internal */
export type UpdateTriggerInstanceForm$Outbound = {
  config?: { [k: string]: any } | undefined;
  environment_id?: string | undefined;
  id: string;
  name?: string | undefined;
  status?: string | undefined;
  target_display?: string | undefined;
  target_kind?: string | undefined;
  target_ref?: string | undefined;
};

/** @internal */
export const UpdateTriggerInstanceForm$outboundSchema: z.ZodMiniType<
  UpdateTriggerInstanceForm$Outbound,
  UpdateTriggerInstanceForm
> = z.pipe(
  z.object({
    config: z.optional(z.record(z.string(), z.any())),
    environmentId: z.optional(z.string()),
    id: z.string(),
    name: z.optional(z.string()),
    status: z.optional(UpdateTriggerInstanceFormStatus$outboundSchema),
    targetDisplay: z.optional(z.string()),
    targetKind: z.optional(UpdateTriggerInstanceFormTargetKind$outboundSchema),
    targetRef: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      environmentId: "environment_id",
      targetDisplay: "target_display",
      targetKind: "target_kind",
      targetRef: "target_ref",
    });
  }),
);

export function updateTriggerInstanceFormToJSON(
  updateTriggerInstanceForm: UpdateTriggerInstanceForm,
): string {
  return JSON.stringify(
    UpdateTriggerInstanceForm$outboundSchema.parse(updateTriggerInstanceForm),
  );
}
